import { render, staticRenderFns } from "./ScheduleOrganization.vue?vue&type=template&id=71b1912b"
import script from "./ScheduleOrganization.vue?vue&type=script&lang=js"
export * from "./ScheduleOrganization.vue?vue&type=script&lang=js"
import style0 from "./ScheduleOrganization.vue?vue&type=style&index=0&id=71b1912b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports